<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section>
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <span>What's On</span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a routerLink="/movies">{{title}}</a>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">
        <a>{{moviesPageData?.movie?.title}}</a>
      </li>
    </ul>

    <!-- MOVIE OVERVIEW -->
    <section *ngIf="moviesPageData?.movie" class="movie-overview">
      <ion-grid class="ion-no-padding ion-no-margin">
        <ion-row>
          <!-- DESKTOP FEATURED IMAGE -->
          <ion-col
            *ngIf="desktop"
            size="12"
            size-md="auto"
            class="movie-img-column">
            <div
              class="movie-img-wrapper ion-align-items-center ion-justify-content-center">
              <ng-container
                *ngIf="moviesPageData?.movie?.poster_file || moviesPageData?.movie?.poster?.url; else placeholderPoster">
                <app-img-format
                  *ngIf="moviesPageData?.movie?.poster_file"
                  [src]="moviesPageData.movie.poster_file"
                  [alt]=""
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
                <app-img-format
                  *ngIf="moviesPageData?.movie?.poster?.url"
                  [src]="moviesPageData.movie.poster.url"
                  [alt]="moviesPageData.movie.poster.alt"
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
              </ng-container>
              <ng-template #placeholderPoster>
                <app-img-format
                  src="/assets/placeholder-movie.png"
                  [alt]="moviesPageData.movie.poster.alt"
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
              </ng-template>
            </div>
          </ion-col>

          <ion-col size="12" size-md class="movie-overview-details">
            <ion-row class="ion-align-items-center">
              <!-- TITLE -->
              <ion-col>
                <h2 class="movie-title">{{moviesPageData?.movie.title}}</h2>

                <!-- CATEGORY -->
                <ion-text color="tertiary">
                  <h2 class="movie-rating">
                    {{moviesPageData.movie.age_restriction ?
                    moviesPageData.movie.age_restriction :
                    moviesPageData.movie.rating}}
                  </h2>
                </ion-text>
              </ion-col>

              <!-- SOCIAL SHARE -->
              <ion-col size="auto" class="social-share">
                <a (click)="presentPopover($event)">
                  <ion-icon
                    color="dark"
                    name="share-outline"
                    slot="icon-only"></ion-icon>
                </a>
              </ion-col>

              <!-- FAVORTIE -->
              <ion-col size="auto" class="favorite">
                <app-favorite-item
                  [title]="moviesPageData.movie.title"
                  [slug]="moviesPageData.movie.slug"></app-favorite-item>
              </ion-col>
            </ion-row>

            <!-- MOBILE FEATURED IMAGE -->
            <div
              *ngIf="!desktop"
              class="movie-img-wrapper ion-align-items-center ion-justify-content-center">
              <ng-container
                *ngIf="moviesPageData?.movie?.poster_file || moviesPageData?.movie?.poster?.url; else placeholderPoster">
                <app-img-format
                  *ngIf="moviesPageData?.movie?.poster_file"
                  [src]="moviesPageData.movie.poster_file"
                  alt=""
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
                <app-img-format
                  *ngIf="moviesPageData?.movie?.poster?.url"
                  [src]="moviesPageData.movie.poster.url"
                  [alt]="moviesPageData.movie.poster.alt"
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
              </ng-container>
              <ng-template #placeholderPoster>
                <app-img-format
                  src="/assets/placeholder-movie.png"
                  alt=""
                  [aspectRatio]="'89:132'"
                  [disableLazyLoad]="true"></app-img-format>
              </ng-template>
            </div>

            <!-- MOVIE DETAILS -->
            <ion-grid class="movie-details">
              <ion-row>
                <ion-col
                  *ngIf="moviesPageData?.movie?.running_time || moviesPageData?.movie?.runtime"
                  size="6"
                  size-md="4">
                  <ion-text color="medium">
                    <p class="movie-detail-heading ion-no-margin">
                      Running time
                    </p>
                  </ion-text>
                  {{moviesPageData?.movie?.running_time ?
                  moviesPageData?.movie?.running_time :
                  moviesPageData?.movie?.runtime}}
                </ion-col>
                <ion-col size="6" size-md="4">
                  <ion-text color="medium">
                    <p class="movie-detail-heading ion-no-margin">
                      Release date
                    </p>
                  </ion-text>
                  {{moviesPageData?.movie?.release_date ?
                  moviesPageData?.movie?.release_date :
                  moviesPageData?.movie?.opening_date_string}}
                </ion-col>
                <ion-col
                  size="6"
                  size-md="4"
                  *ngIf="moviesPageData?.movie?.genres">
                  <ng-container>
                    <ion-text color="medium">
                      <p class="movie-detail-heading ion-no-margin">Genre</p>
                    </ion-text>
                    <ng-container
                      *ngIf="moviesPageData?.movie?.genres && moviesPageData?.movie?.genres[0]?.name; else genresStringArray">
                      <ion-text
                        *ngFor="let genre of moviesPageData?.movie?.genres; index as i"
                        ><ng-container *ngIf="i !== 0">, </ng-container
                          >{{genre.name | titlecase}}</ion-text
                      >
                    </ng-container>
                    <ng-template #genresStringArray>
                      {{moviesPageData?.movie?.genres?.join(', ')}}
                    </ng-template>
                  </ng-container>
                </ion-col>
                <ion-col
                  *ngIf="moviesPageData?.movie?.director || moviesPageData?.movie?.cast?.directors"
                  size="6"
                  size-md="4">
                  <ion-text color="medium">
                    <p class="movie-detail-heading ion-no-margin">Director</p>
                  </ion-text>
                  {{moviesPageData?.movie?.director ?
                  moviesPageData?.movie?.director :
                  moviesPageData?.movie?.cast?.directors[0] ?
                  moviesPageData?.movie?.cast?.directors[0].FirstName + ' ' +
                  moviesPageData?.movie?.cast?.directors[0].LastName : ''}}
                </ion-col>
                <ion-col
                  *ngIf="moviesPageData?.movie?.cast_headline || moviesPageData?.movie?.cast_secondary || moviesPageData?.movie?.cast?.actors"
                  size="12"
                  size-md="8">
                  <ion-text color="medium">
                    <p class="movie-detail-heading ion-no-margin">Cast</p>
                  </ion-text>
                  <ng-container
                    *ngIf="moviesPageData?.movie?.cast?.actors; else castHeadline">
                    <ion-text
                      *ngFor="let actor of moviesPageData?.movie?.cast?.actors; index as i"
                      ><ng-container *ngIf="i !== 0">, </ng-container
                      >{{actor.FirstName.trim()}}
                      {{actor.LastName.trim()}}</ion-text
                    >
                  </ng-container>
                  <ng-template #castHeadline>
                    {{moviesPageData?.movie?.cast_headline ?
                    moviesPageData?.movie?.cast_headline :
                    moviesPageData?.movie?.cast_secondary}}
                  </ng-template>
                </ion-col>
              </ion-row>
            </ion-grid>

            <div
              class="movie-booking"
              *ngIf="!moviesPageData?.movie?.comingSoon">
              <section class="movie-days">
                <a
                  class="movie-type"
                  *ngFor="let cinemaType of cinemaTypes"
                  (click)="setCinemaSessions(cinemaType)"
                  [class.selected]="cinemaType === selectedCinemaType"
                  >{{cinemaType.title}}</a
                >
              </section>

              <section class="movie-days">
                <a
                  *ngFor="let day of daySlots"
                  class="movie-day"
                  [class.selected]="day === selectedCinemaDay"
                  (click)="selectCinemaDay(day)">
                  <span>{{day.label | date:'EEE'}}</span>
                  {{day.label | date:'d'}}
                </a>
              </section>

              <ion-grid
                *ngIf="cinemaProvider?.slug === 'numetro'"
                class="movie-times">
                <ion-row>
                  <ion-col *ngFor="let time of timeSlots">
                    <a
                      class="movie-time"
                      [class.selected]="time === selectedCinemaTime && bookNow"
                      [class.disabled]="cinemaProvider?.slug !== 'numetro'"
                      (click)="selectCinemaTime(time)"
                      >{{time}}</a
                    >
                  </ion-col>
                </ion-row>
              </ion-grid>

              <ion-note *ngIf="bookingError" color="danger">
                {{ bookingError }}
              </ion-note>
              
              <app-button
                *ngIf="cinemaProvider?.slug === 'sterkinekor' && moviesPageData?.movie?.allow_ticket_sales" type="secondary" [href]="skBookingLink" target="_blank"
                [icon]="{ name: 'arrow-right', position: 'right' }" 
                position="left"
                class="ion-margin-top">
                Book now
              </app-button>

              <div
                *ngIf="cinemaProvider?.slug === 'numetro' && bookNow && selectedCinemaTime"
                class="ion-text-end">
                <app-button
                  type="secondary" (click)="nuMetroBooking()"
                  [icon]="{ name: 'arrow-right', position: 'right' }" 
                  position="left"
                  class="ion-margin-top">
                  Book now
                </app-button>
              </div>
            </div>

            <!-- SYNOPSIS -->
            <ion-text color="medium" class="movie-synopsis">
              {{moviesPageData?.movie?.synopsis_short ?
              moviesPageData?.movie?.synopsis_short :
              moviesPageData?.movie?.synopsis}}
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <!-- TRAILER -->
    <div *ngIf="trailer" class="iframe-wrapper">
      <div
        class="iframe-wrapper-inner"
        [innerHTML]="trailer | youtube | safe: 'html'"></div>
    </div>
  </section>

  <!-- RELATED CONTENT -->
  <div
    class="related-content ion-content-stretched swiper-stretched"
    *ngIf="moviesPageData?.relatedContent && moviesPageData?.relatedContent.length > 0">
    <section>
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">
          Latest Movies at {{ cinemaProvider.name }}
        </h2>
      </ion-text>
      <ion-slides pager="true" [options]="slideOpts">
        <ion-slide
          *ngFor="let item of moviesPageData?.relatedContent"
          class="ion-align-items-start ion-justify-content-start">
          <app-movie-card [movie]="item"></app-movie-card>
        </ion-slide>
      </ion-slides>
    </section>
  </div>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
